import React from "react";
import { UserMinus, X } from "lucide-react";
import { safeUserLabel } from "../../utils/adminLevelUtils";

/**
 * Shown before unassigning a user's admin level (Users mode).
 * Confirming calls DELETE /admin-levels/assign/:userId — the personal
 * __user__ level row is intentionally kept so re-promoting the user later
 * restores their old configuration.
 */
const RemoveLevelModal = ({ user, onConfirm, onClose, styles, theme, t }) => {
  if (!user) return null;

  return (
    <div style={styles.modal} onClick={onClose}>
      <div
        style={{ ...styles.modalContent, maxWidth: "440px" }}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={styles.modalHeader}>
          <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
            <span style={{
              width: "40px", height: "40px", borderRadius: "12px",
              display: "flex", alignItems: "center", justifyContent: "center",
              background: theme === "dark" ? "rgba(239,68,68,0.2)" : "rgba(239,68,68,0.1)",
            }}>
              <UserMinus size={20} style={{ color: theme === "dark" ? "#f87171" : "#dc2626" }} />
            </span>
            <h3 style={{ ...styles.modalTitle, fontSize: "18px" }}>{t.removeLevelTitle}</h3>
          </div>
          <button onClick={onClose} style={styles.iconButton} type="button">
            <X size={18} style={{ color: theme === "dark" ? "#94a3b8" : "#64748b" }} />
          </button>
        </div>

        <p style={{
          fontSize: "13.5px", lineHeight: 1.7, margin: "0 0 8px",
          color: theme === "dark" ? "#cbd5e1" : "#475569",
        }}>
          <strong>{safeUserLabel(user)}</strong> {t.removeLevelBody}
        </p>
        <p style={{
          fontSize: "12.5px", lineHeight: 1.6, margin: "0 0 24px",
          color: theme === "dark" ? "#94a3b8" : "#64748b",
        }}>
          {t.removeLevelKept}
        </p>

        <div style={styles.modalFooter}>
          <button
            type="button"
            style={{ ...styles.button, ...styles.secondaryButton }}
            onClick={onClose}
          >
            {t.cancel}
          </button>
          <button
            type="button"
            style={{ ...styles.button, background: "#dc2626", color: "#ffffff" }}
            onClick={onConfirm}
          >
            {t.removeLevelConfirm}
          </button>
        </div>
      </div>
    </div>
  );
};

export default RemoveLevelModal;
